import { HCPState } from './../types/hcp.types'
import { createSlice } from '@reduxjs/toolkit'

const initialState: HCPState = {
  hcpProgramData: null,
  hcpDataById: null,
  hcpEnrollmentJSON: null,
  ids: {
    entityId: null,
    layoutId: null,
  },
  hcpProgramWorkingHours: null,
  hcpDataByApi: null,
  fontStyles: [],
  isStepperConfigured: true,
  editProgramId: null,
  editPortalType: null,
  isResultDiscarded: {
    branding: false,
    enrollmentFlow: false,
    confirmationPage: false,
    launchPortal: false,
  },
  isNewDomainDisabled: false,
  isNewSubDomain: false,
  editPortalStatus: null,
  currentEnrollmentFlowId: null,
  masterFlowEnabled: false,
}

const hcpPortalSlice = createSlice({
  name: 'hcp',
  initialState: initialState,
  reducers: {
    updateHCPProgramData: (state: HCPState, action) => {
      state.hcpProgramData = action.payload
    },
    updateCurrentEnrollmentFlowId: (state: HCPState, action) => {
      state.currentEnrollmentFlowId = action.payload
    },
    setMasterFlowEnabled: (state: HCPState, action) => {
      state.masterFlowEnabled = action.payload
    },
    updateIsStepperConfiguredData: (state: HCPState, action) => {
      state.isStepperConfigured = action.payload
    },
    updateisNewDomainDisabled: (state: HCPState, action) => {
      state.isNewDomainDisabled = action.payload
    },
    updateisNewSubDomain: (state: HCPState, action) => {
      state.isNewSubDomain = action.payload
    },
    updateIsResultDiscarded: (state: HCPState, action) => {
      const key = action?.payload?.key as keyof typeof state.isResultDiscarded
      const value = action?.payload?.value
      if (key in state.isResultDiscarded) {
        state.isResultDiscarded[key] = value
      }
    },
    resetResultDiscarded: (state: HCPState) => {
      state.isResultDiscarded = initialState?.isResultDiscarded
    },
    updateEditProgramId: (state: HCPState, action) => {
      state.editProgramId = action.payload
    },
    updateEditPortalStatus: (state: HCPState, action) => {
      state.editPortalStatus = action.payload
    },
    updateEditPortalType: (state: HCPState, action) => {
      state.editPortalType = action.payload
    },
    updateHCPDataById: (state: HCPState, action) => {
      state.hcpDataById = action.payload
    },
    updateHCPEnrollmentJSON: (state: HCPState, action) => {
      state.hcpEnrollmentJSON = action.payload.layout_data
      state.ids.entityId = action.payload.entity_id
      state.ids.layoutId = action.payload.id
    },
    updateHCPProgramWorkingHoursData: (state: HCPState, action) => {
      state.hcpProgramWorkingHours = action?.payload
    },
    getHCPEnrollmentJSONAction: () => {
      return
    },
    getHCPProgramDataAction: () => {
      return
    },
    getHCPProgramWorkingHoursAction: () => {
      return
    },
    getHCPDataByIdAction: () => {
      return
    },
    putHCPDataAction: () => {
      return
    },
    getHCPDataByApiAction: () => {
      return
    },
    updateHCPDataByApi: (state: HCPState, action) => {
      state.hcpDataByApi = action.payload
    },
    updateFontStyles: (state: HCPState, action) => {
      state.fontStyles = action.payload
    },
    getFontStylesAction: () => {
      return
    },
    updateHCPValueDataAction: () => {
      return
    },
  },
})

export const {
  updateHCPProgramData,
  getHCPProgramDataAction,
  putHCPDataAction,
  getHCPDataByIdAction,
  updateHCPDataById,
  getHCPEnrollmentJSONAction,
  updateHCPEnrollmentJSON,
  getHCPProgramWorkingHoursAction,
  updateHCPProgramWorkingHoursData,
  getHCPDataByApiAction,
  updateHCPDataByApi,
  updateHCPValueDataAction,
  updateFontStyles,
  getFontStylesAction,
  updateIsStepperConfiguredData,
  updateEditProgramId,
  updateIsResultDiscarded,
  resetResultDiscarded,
  updateEditPortalType,
  updateisNewDomainDisabled,
  updateisNewSubDomain,
  updateEditPortalStatus,
  updateCurrentEnrollmentFlowId,
  setMasterFlowEnabled,
} = hcpPortalSlice.actions
export default hcpPortalSlice.reducer
